import React, { useState } from "react";
import { motion } from "framer-motion";
import { useGlobalContext } from "../../context";
import { blogsContent } from "../../data/blogs";
import { Loader } from "../tools/Loader";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui";
import { LayoutContainer } from "../common";

export const Blogs = () => {
  const { t } = useGlobalContext();
  const [loadingImg, setLoadingImg] = useState(true);

  return (
    <LayoutContainer className="min-h-[83vh] flex-1 overflow-y-auto">
      <section className="container mx-auto py-10">
        <div className="flex items-center gap-4 pb-4">
          <h2 className="text-2xl font-bold text-primary">
            {t("navbar.blogs")}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-6">
          {blogsContent.map((blog, index) => (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              key={index}
            >
              <Card className="overflow-hidden  border border-border">
                <div className="relative w-full h-48">
                  {loadingImg && <Loader />}
                  <a href={blog.link} target="_blank" rel="noopener noreferrer">
                    <img
                      src={blog.imgBackground}
                      alt={blog.alt}
                      onLoad={() => setLoadingImg(false)}
                      className="object-center w-full h-full"
                    />
                  </a>
                </div>
                <CardContent className="p-4">
                  <a href={blog.link} target="_blank" rel="noopener noreferrer">
                    <h3 className="text-lg font-semibold text-primary">
                      {blog.blogTitle}
                    </h3>
                  </a>
                  <p className="text-sm text-muted-foreground mt-2">
                    📅 {blog.publishedOn}
                  </p>
                  <div className="flex justify-end mt-3">
                    <Button variant="secondary">
                      <a
                        href={blog.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read More
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </section>
    </LayoutContainer>
  );
};
